// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e1ecb17a","726":"c7d53b3a","821":"ac30b537"}[chunkId] + ".chunk.js";
};